<template>
  <transition name="slideDown">
    <modal title="Add Tags" v-if="show">
      <div class="form-horizontal">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name"
                class="col-sm-2 control-label">
                Name
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="optionForm.tags.name">
              </div>
            </div>

            <div class="form-group">
              <label for="slug"
                class="col-sm-2 control-label">
                Slug
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="slug"
                  placeholder="Slug"
                  v-model="optionForm.tags.slug">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary"
              @click="emit('add')">
              Add
            </button>
          </div>
        </div>
      </div>
    </modal>
  </transition>
</template>

<script>
import Modal from '@/components/modules/common/Modal';

export default {
  props: {
    optionForm: {
      type: Object,
      required: true,
    },

    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Modal,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/products/partials/ModalTags.vue